import { render } from "./PuxRequired.pug?vue&type=template&id=cb1b086a&lang=pug"
import script from "./PuxRequired.js?vue&type=script&lang=js"
export * from "./PuxRequired.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__